<template>
    <div v-if="loading" class="space-y-4">
        <Message status="info">{{ $t('loading-event-series') }}</Message>
    </div>
    <div v-if="!loading && eventSeries.length === 0" class="space-y-4">
        <EmptyState>
            <template #description>
                {{ $t('no-event-series') }}
            </template>
            <template #call-to-action>
                <LinkButton
                    size="Base"
                    variant="Info-Strong"
                    :disabled-explanation="createEventSeriesDisabledExplanation"
                    :to="getCreateEventSeriesLink()"
                >
                    <template #icon>
                        <PlusIcon class="size-5" />
                    </template>
                    {{ $t('event-series-create') }}
                </LinkButton>
            </template>
        </EmptyState>
    </div>

    <div v-if="!loading && eventSeries.length > 0" class="space-y-2">
        <EventSeriesCard
            v-for="series in eventSeries"
            :key="series.id"
            :series="series"
            :link-target="getEventSeriesLink(series.id)"
            :link-text="series.nameShort"
            :is-single-event="series.singleEvent"
        />
    </div>
</template>

<script setup lang="ts">
import auth from '@/auth/auth';
import LinkButton from '@/components/Button/LinkButton.vue';
import EmptyState from '@/components/EmptyState/EmptyState.vue';
import PlusIcon from '@/components/Icon/PlusIcon.vue';
import Message from '@/components/Message/Message.vue';
import { GetEventSeriesBaseDataDocument } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { useFluent } from 'fluent-vue';
import { computed } from 'vue';
import { getCreateEventSeriesLink, getEventSeriesLink } from '../event';
import EventSeriesCard from './EventSeriesCard.vue';

const fluent = useFluent();

const { result: getEventSeriesQuery, loading } = useQuery(GetEventSeriesBaseDataDocument);
const eventSeries = computed(() => {
    return getEventSeriesQuery.value?.eventSerieses?.nodes || [];
});
const createEventSeriesDisabledExplanation = computed(() =>
    auth.isAdmin() ? undefined : fluent.$t('no-permission-to-create'),
);
</script>
